import React, { PureComponent } from 'react';
import {
  string, func, shape, bool,
} from 'prop-types';
import noop from 'lodash/noop';
import CreditCard from './components/CreditCard';

import injectI18n from '../../../shared/utils/injectI18n';
import injectService from '../../../shared/service';
import servicesConfig from './services.json';
import { appendCss } from '../../../shared/utils/commonUtils';
import WidgetError from '../../../shared/components/WidgetError';
import AMS from '../../../shared/lib/ams-security-api';

window.AMS = window.AMS || AMS;

class PCICreditCardWidget extends PureComponent {
  static propTypes = {
    locale: string,
    accessToken: string.isRequired,
    kelowna: bool,
    widgetAPIServerHost: string.isRequired,
    amsAPIServerHost: string.isRequired,
    onDataReady: func,
    services: shape({
      getPCIClientConfig: func.isRequired,
    }).isRequired,
    triggers: shape({
      commitTrigger: func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    locale: 'en_US',
    kelowna: false,
    onDataReady: noop,
  }

  state = {
    errorCode: '',
  }

  constructor(props) {
    super(props);
    const { triggers: { commitTrigger } } = props;
    this.triggers = {
      ...props.triggers,
      commitTrigger: (trigger) => {
        this.proxyCommitTrigger = trigger;
      },
    };
    commitTrigger((_, callback) => {
      this.proxyCommitTrigger(_, (result = {}) => {
        this.errorHandler(result.errorCode);
        callback(result);
      });
    });
  }

  errorHandler = (errorCode) => {
    this.setState({ errorCode });
  }

  componentDidMount() {
    const {
      services, onDataReady, kelowna, accessToken, clientSessionId,
    } = this.props;
    services.getPCIClientConfig({
      params: { kelowna, accessCode: accessToken, clientSessionId },
      resolve: (resp) => {
        const {
          amsConfig,
          customiseStyleUrl,
          checkoutPageStyleUrl,
          horizontal,
          paymentAccountInfo: {
            creditCardInfo: {
              newAccountInfo, savedAccountInfo,
            } = {},
          } = {},
        } = JSON.parse(resp);
        if (checkoutPageStyleUrl) {
          appendCss(checkoutPageStyleUrl);
        }
        if (customiseStyleUrl) {
          appendCss(customiseStyleUrl);
        }
        this.setState({
          creditCardInfo: {
            amsConfig,
            horizontal,
            creditCardPaymentInfo: { newAccountInfo, savedAccountInfo },
          },
        }, onDataReady);
      },
    });
  }

  render() {
    const { ...rest } = this.props;
    const { creditCardInfo, errorCode } = this.state;
    if (creditCardInfo) {
      return (
        <React.Fragment>
          <WidgetError errMsgCode={errorCode} />
          <CreditCard {...rest} {...creditCardInfo} triggers={this.triggers} />
        </React.Fragment>
      );
    }
    return null;
  }
}

export default injectService(servicesConfig)(injectI18n(PCICreditCardWidget));
